import React from 'react';
import CustomizePageProvider from './CustomizeContext/CustomizePageProvider';
import CustomizePageContent from './CustomizePageContent';
import CustomizeLanguageSelector from './LanguageSelector';

const CustomizePage = ({ ecmContent }) => {
  const pageConfig = ecmContent.config;
  return (
    <CustomizePageProvider pageConfig={pageConfig}>
      <CustomizeLanguageSelector />
      <CustomizePageContent ecmContent={ecmContent} />
    </CustomizePageProvider>
  );
};

export default CustomizePage;
